const ReportView = require('./ReportView');

class ReportSingleView extends ReportView {
  reportCheckBoxes;

  constructor(modal, btn) {
    super(modal, btn);

    this.reportCheckBoxes = $('input.report-checkbox');
  }

  init() {
    super.init();

    this.updateHeading(__('You are reporting title'));

    this.fillSongData();
    this.showHideElements();

    this.reportedTitles = [{
      idSong: this.buttonData.idSong,
      idHymn: this.buttonData.idHymn
    }];
  }

  showHideElements() {
    this.modal.find('#report-titles-body').show();
    this.modal.find('#report-no-titles-body').hide();

    this.modal.find('#report-all-info').hide();
    this.modal.find('#report-single-info').show();
  }

  fillSongData() {
    this.modal.find('#title').html(`"${this.buttonData.title}"`);
    this.modal.find('#subtitle').html(this.buttonData.subtitle);
    this.modal.find('#detail').html(this.buttonData.detail);
    this.modal.find('#tune').html(this.buttonData.tune);
  }
}

module.exports = ReportSingleView